import React from 'react';
import QuantitySelector from '../QuantitySelector';
import FeatureList from '../FeatureList';
import StockStatus from '../StockStatus';
import { translate } from '../../Services/translation';
import { culture } from '../../Services/culture';
import formatCurrencyService from '../../Services/formatCurrencyService';
import { currency } from '../../Services/currency';
import { useSelector } from 'react-redux';



const BuyBox = ({ buy, quantity, articleNumber, updateQuantity, comment, stockInfoMessage, totalPrice, currentPrice, stockstatus, originalPrice, formatter, enabled, toggleOptions, packagingQuantity,
    productInfoMessage, featureList, isSuperBuilderActive, scroll }) =>  {    
    
    const superBuilder = useSelector((state) => state.superBuilder);
    const superBuilderValid = superBuilder.mandatorySectionsValid;

    return (
    <div className={'buy-box' + (isSuperBuilderActive ? ' buy-box--superbuilder' : '')}>
        <div className="buy-box__info">
            <StockStatus data={stockstatus}></StockStatus>
            {stockInfoMessage &&
                <div className="product-comment">
                    {stockInfoMessage}
                </div>
            }
            {comment &&
                <div className="product-comment">
                    {comment}
                </div>
            }
            {stockstatus.onDisplayText &&
                <div className="product-ondisplay">
                    {stockstatus.onDisplayText}
                </div>
            }
        </div>
        <div className={'buy-box__main' + (stockstatus.onlyInStore ? ' buy-box__main-store' : '')}>
            <div className="price-box">
                <div itemProp="offers" itemScope itemType="https://schema.org/Offer" className={originalPrice != totalPrice ? 'price-box__campaign' : ''}>
                    {originalPrice != totalPrice &&
                        <span itemProp="price" content={originalPrice} className="price-box__original-price">{formatCurrencyService.formatCurrency(formatter, originalPrice)}</span>
                    }
                    <span itemProp={originalPrice != totalPrice ? "sale_price" : "price"} content={totalPrice} 
                    className="price-box__current-price">{formatCurrencyService.formatCurrency(formatter, totalPrice)}</span>
                    <meta itemProp="priceCurrency" content={currency}></meta>
                </div>
            </div>
            {!stockstatus.onlyInStore && <div className="buy-box__inner">
                <div className="buy-box__controls">
                    <div className="buy-box__quantity-container">
                        {productInfoMessage && (
                            <div className="product-info-message">
                                {productInfoMessage}
                            </div>
                        )}
                        <div className="buy-box__quantity-small">
                            <QuantitySelector isSmall={true} quantity={quantity} articleNumber={articleNumber} packagingQuantity={packagingQuantity} onChange={updateQuantity}></QuantitySelector>
                        </div>
                        <div className="buy-box__quantity-large">
                            <QuantitySelector isSmall={false} quantity={quantity} articleNumber={articleNumber} packagingQuantity={packagingQuantity} onChange={updateQuantity}></QuantitySelector>
                        </div>
                    </div>
                    {isSuperBuilderActive && !superBuilderValid && !enabled && (
                        <button role="button" className={'buy-box__buy'} onClick={() => { scroll() }}>{translate('configurator.superbuilder.button.configure')}</button>
                    )}
                    {isSuperBuilderActive && enabled && superBuilderValid && (
                        <button role="button" className={'buy-box__buy' + (enabled ? '' : ' buy-box__buy--disabled')} onClick={() => { buy() }}>{translate('cart.add')}</button>
                    )}
                    {isSuperBuilderActive && !enabled && superBuilderValid && (
                        <button role="button" className={'buy-box__buy'} onClick={() => { toggleOptions() }}>{translate('configurator.button.configure')}</button>
                    )}
                    {!isSuperBuilderActive && enabled && (
                        <button role="button" className={'buy-box__buy' + (enabled && !stockstatus.discontinued ? '' : ' buy-box__buy--disabled')} onClick={() => { buy() }}>{translate('cart.add')}</button>
                    )}
                    {!isSuperBuilderActive && !enabled && (
                        <button role="button" className={'buy-box__buy' + (!stockstatus.discontinued ? '' : ' buy-box__buy--disabled')} onClick={() => { toggleOptions() }}>{translate('configurator.button.configure')}</button>
                    )}
                </div>
                {stockstatus.onlyInStore && <div className="buy-box__inner">
                    <div className="buy-box__controls-store">
                        <div className="buy-box__quantity-container">
                            {productInfoMessage && (
                                <div className="product-info-message">
                                    {productInfoMessage}
                                </div>
                            )}
                        </div>
                        <button role="button" className="buy-box__buy buy-box__buy--disabled">{translate('stockstatus.store')}</button>
                    </div>
                </div>}
            </div>}
            {!stockstatus.onlyInStore && <div className={'price-box-partpayment' + (productInfoMessage ? ' has-bundle-message' : '')}>
                <div>
                    <klarna-placement data-key="top-strip-promotion-auto-size"
                        data-locale={culture}></klarna-placement>
                </div>
            </div>}
            <FeatureList featureList={featureList}></FeatureList>
        </div>
    </div>
)
                            }

export default BuyBox;